<template>
   <div>
      <h5>About you</h5>

      <div class="form-group _margin-bottom-20">
         <div class="col-xs-7">
            <form-label id="titleId">Title</form-label>
            <validation-messages label="Title" :$v="$v.form.titleId">
               <select-list id="titleId" v-model="personalDetails.titleId" value-key="id" :list="titleList"
                  :error="$v.form.titleId.$error" />
            </validation-messages>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-sm-7">
            <form-label id="firstName">First Name</form-label>
            <validation-messages label="First Name" :$v="$v.form.firstName">
               <form-field id="firstName" type="alpha-space" v-model="personalDetails.firstName" maxlength="100"
                  :error="$v.form.firstName.$error" />
            </validation-messages>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-sm-7">
            <form-label id="lastName">Last Name</form-label>
            <validation-messages label="Last Name" :$v="$v.form.lastName">
               <form-field id="lastName" type="alpha-space" v-model="personalDetails.lastName" maxlength="100"
                  :error="$v.form.lastName.$error" />
            </validation-messages>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-sm-7">
            <form-label id="dateOfBirth">Date of Birth</form-label>
            <validation-messages label="Date of Birth" :$v="$v.form.dateOfBirth">
               <date-field id="dateOfBirth" :dob="true" v-model="personalDetails.dateOfBirth"
                  :error="$v.form.dateOfBirth.$error"
                  @change="personalDetails.dateOfBirth ? $v.form.dateOfBirth.$touch() : null" />
               <template v-slot:error>
                  <div v-if="$v.form.dateOfBirth.$error">
                     You must be at least 18 year old
                  </div>
               </template>
            </validation-messages>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-sm-7">
            <form-label id="dayTimePhone">Phone Number</form-label>
            <validation-messages label="Phone Number" :$v="$v.form.dayTimePhone">
               <form-field id="dayTimePhone" type="number" v-model="personalDetails.dayTimePhone"
                  :error="$v.form.dayTimePhone.$error" maxlength="11" minlength="10"
                  @blur="$v.form.dayTimePhone.$touch()" />
            </validation-messages>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-sm-7">
            <form-label id="emailAddress">Email</form-label>
            <validation-messages label="Email" :$v="$v.form.emailAddress">
               <form-field id="emailAddress" type="lowercase" v-model="personalDetails.emailAddress"
                  :error="$v.form.emailAddress.$error" @blur="$v.form.emailAddress.$touch()" />
            </validation-messages>
         </div>
      </div>

      <div class="form-group _margin-bottom-20">
         <div class="col-sm-7">
            <form-label id="employmentStatus">Employment Status</form-label>
            <validation-messages label="Employment Status" :$v="$v.form.employmentStatusId">
               <select-list id="employmentStatus" v-model="personalDetails.employmentStatusId" value-key="id"
                  :list="employmentStatusList" :error="$v.form.employmentStatusId.$error" />
            </validation-messages>
         </div>
      </div>

      <div class="sticky-footer">
         <div class="col-xs-5">
            <uiv-btn type="link" block @click="$router.go(-1)">Back</uiv-btn>
         </div>
         <div class="col-xs-7">
            <uiv-btn type="primary" block @click="onNext">Next</uiv-btn>
         </div>
      </div>
   </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
   required, helpers, maxLength, minLength, numeric
} from 'vuelidate/lib/validators';

export default {
   name: 'CustomerDetails',
   computed: {
      ...mapState({
         personalDetails: ({ personal_details_customer }) => personal_details_customer,
         employmentStatusList: ({ lookups }) => lookups.employmentStatuses,
         titleList: ({ lookups }) => lookups.titles
      })
   },
   mounted() {
      this.form = this.personalDetails;
   },
   validations() {
      return {
         form: {
            titleId: { required },
            firstName: { required },
            lastName: { required },
            dateOfBirth: {
               required,
               over18(value) {
                  if (value) {
                     const split = value.split('-');
                     const [year, month, day] = split.map(d => Number(d));

                     return new Date(year + 18, month - 1, day) <= new Date();
                  }

                  return true;
               }
            },
            emailAddress: {
               required,
               regex: helpers.regex('email', /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/)
            },
            dayTimePhone: {
               required,
               numeric,
               maxLength: maxLength(11),
               minLength: minLength(10),
               regex: helpers.regex('phone', /^(?=.*\d)(?=.*[1-9]).{1,11}$/)
            },
            employmentStatusId: { required }
         }
      }
   },
   methods: {
      ...mapActions({
         goToQuestion: 'personal_details_questions/goToQuestion'
      }),
      onNext() {
         this.$v.form.$touch();
         if (this.$v.form.$invalid) return;
         this.$scrollTo('.fullscreen-card');
         this.goToQuestion('address');
      }
   }
};
</script>

<style lang="scss"></style>
